import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import { Validation } from '@singularsystems/neo-core';
export var EditorParentType;
(function (EditorParentType) {
    EditorParentType[EditorParentType["FormGroup"] = 1] = "FormGroup";
    EditorParentType[EditorParentType["Column"] = 2] = "Column";
})(EditorParentType || (EditorParentType = {}));
var FormContextParams = /** @class */ (function () {
    function FormContextParams() {
        /** The validation display mode to apply to all controls. */
        this.validationDisplayMode = Validation.DisplayMode.AfterBlur;
        /** True if all controls in this section should be readonly. */
        this.allReadOnly = false;
        /** True if all controls in this section should be disabled. */
        this.allDisabled = false;
        /** True if all labels should be hidden. */
        this.suppressLabels = undefined;
    }
    return FormContextParams;
}());
export { FormContextParams };
export var FormContext = React.createContext(new FormContextParams());
/**
 * Allows the attributes of multiple child form controls to be set at a parent level.
 */
var FormContextProvider = /** @class */ (function (_super) {
    __extends(FormContextProvider, _super);
    function FormContextProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormContextProvider.prototype.render = function () {
        var _a = this.props, children = _a.children, newContextParams = __rest(_a, ["children"]);
        var newContext = __assign(__assign({}, this.context), newContextParams);
        return (React.createElement(FormContext.Provider, { value: newContext }, children));
    };
    FormContextProvider.contextType = FormContext;
    return FormContextProvider;
}(React.Component));
export { FormContextProvider };
